import React, { useEffect } from "react";
import Header from "../../components/header/Header";
import Slider from "../../components/slider/SliderAnimation";
import About from "../../components/about/AboutAnimation";
import Resume from "../../components/resume/ResumeAnimation";
import Portfolio from "../../components/portfolio/PortfolioAnimation";
import Testimonials from "../../components/testimonial/TestimonialAnimation";
import Achievements from "../../components/award/AchievementsAnimation";
import Blog from "../../components/blog/BlogAnimation";
import Contact from "../../components/contact/ContactAnimation";
import ContactInfo from "../../components/contact/ContactInfoAnimation";
import Footer from "../../components/footer/FooterAnimation";
import useDocumentTitle from "../../components/useDocumentTitle";

const HomeOne = () => {
  useDocumentTitle("Lakshay Parnami");

  // Global scroll reveal observer — runs once when page mounts
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const els = document.querySelectorAll(".reveal");
    if (prefersReduced) {
      els.forEach((el) => el.classList.add("visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            observer.unobserve(e.target);
          }
        }),
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="main-left theme-dark">
      <Header />

      <Slider />
      <About />
      <Resume />
      <Portfolio />
      <Testimonials />
      <Achievements />
      <Blog />

      {/* Contact */}
      <section id="contactus" className="d2-section" style={{ background: "var(--bg-surface)", borderTop: "1px solid var(--border)" }}>
        <div className="d2-container">
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "4rem" }}>
            <div className="row">
              <div className="col-lg-5 col-xl-4 m-15px-tb">
                <ContactInfo />
              </div>
              <div className="col-lg-7 ml-auto m-15px-tb">
                <div className="contact-form">
                  <h4>Say Something</h4>
                  <Contact />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomeOne;
